export default function generateLocalStorageKey () {
  return crypto.randomUUID().replace(/-/g, '').slice(0, 32)
}
